import { render, staticRenderFns } from "./gallerySwiper.vue?vue&type=template&id=6dd45a5e&"
import script from "./gallerySwiper.vue?vue&type=script&lang=js&"
export * from "./gallerySwiper.vue?vue&type=script&lang=js&"
import style0 from "./gallerySwiper.vue?vue&type=style&index=0&id=6dd45a5e&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports